import { reminderSelectors } from "./Slice";
export const allMedicalRemindersSelector = (state) => reminderSelectors.selectAll(state.reminders);
export const medicalReminderById = (state, id) => {
    if (!id) {
        return undefined;
    }
    return reminderSelectors.selectById(state.reminders, id);
};
